<template>
  <div v-if="currentCustomer" class="pb-4 flex-1 flex flex-col">
    <NuxtPage />
  </div>
  <div v-else-if="isFetchingCustomers" class="w-full flex flex-1 justify-center items-center">
    <div class="flex flex-col justify-center items-center w-full">
      <GMLoader size="large" />
      {{ t('LOADING_CUSTOMER') }}
    </div>
  </div>
  <div v-else class="w-full flex flex-1 justify-center items-center">
    <GMAlert type="error" class="flex justify-between p-4">
      <div>
        <p>{{t('CUSTOMER_MISSING')}}</p>
        <p class="text-sm opacity-80">
          {{t('CUSTOMER_MISSING_DESCRIPTION')}}
        </p>
      </div>
    </GMAlert>
  </div>
</template>

<script lang="ts">
import {useSearchPanel} from '~/use/ui/searchPanel'
import {useCustomerService} from "~/services/customerService";
import {useTranslation} from "~/composables/useTranslation";
import {GMAlert, GMLoader} from "@gm/components";
import {useIsFetching} from "@tanstack/vue-query";

export default defineComponent({
  name: 'CustomerPage',
  components: {GMAlert, GMLoader},
  setup() {
    const { t } = useTranslation()
    const route = useRoute()
    const customerId = route.params.customerId as string
    const { customerQuery } = useCustomerService()
    const {data: currentCustomer} = customerQuery(customerId)
    const customersFetching = useIsFetching({queryKey: ['customerGetCustomersV2']})
    const customerFetching = useIsFetching({queryKey: ['customerGetCustomerV2']})
    const isFetchingCustomers = computed(() => customersFetching.value > 0 || customerFetching.value > 0)

    const { toggleSearchPanel } = useSearchPanel()
    const pageTitle = ref<string>('')

    onBeforeMount(() => {
      pageTitle.value = ''
      toggleSearchPanel(false)
    })

    useHead({
      title: pageTitle.value
    })

    return {
      t,
      currentCustomer,
      isFetchingCustomers,
    }
  },
})
</script>
